import { render, staticRenderFns } from "./PublicPastes.vue?vue&type=template&id=46852543&scoped=true&"
import script from "./PublicPastes.vue?vue&type=script&lang=js&"
export * from "./PublicPastes.vue?vue&type=script&lang=js&"
import style0 from "./PublicPastes.vue?vue&type=style&index=0&id=46852543&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46852543",
  null
  
)

export default component.exports